import apiClient from "./client";

export const getAdminAccessories = async () => {
  const response = await apiClient.get("/accessories/admin");
  return response.data;
};

/** Full accessory admin row (`pdfDocuments`, etc.). List endpoint may omit PDF fields. */
export const getAdminAccessoryById = async (id) => {
  const response = await apiClient.get(`/accessories/admin/${id}`);
  return response.data;
};

export const createAdminAccessory = async (payload) => {
  const response = await apiClient.post("/accessories/admin", payload);
  return response.data;
};

export const updateAdminAccessory = async ({ id, payload }) => {
  const response = await apiClient.put(`/accessories/admin/${id}`, payload);
  return response.data;
};

/** Create/update every language variant of one accessory (grouped by accessoryKey) in a single call. */
export const saveAdminAccessoryAllLanguages = async (payload) => {
  const response = await apiClient.post("/accessories/admin/save", payload);
  return response.data;
};

export const deleteAdminAccessory = async ({ id }) => {
  await apiClient.delete(`/accessories/admin/${id}`);
};

export const uploadAdminAccessoryImage = async ({ id, file }) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.post(`/accessories/admin/${id}/image`, formData, {
    headers: { "Content-Type": false },
  });
  return response.data;
};

export const removeAdminAccessoryImage = async ({ id }) => {
  const response = await apiClient.delete(`/accessories/admin/${id}/image`);
  return response.data;
};

const assertPdfFile = (file) => {
  if (!file) {
    throw new Error("Please select a PDF file.");
  }
  const byMime = String(file.type || "").toLowerCase() === "application/pdf";
  const byName = /\.pdf$/i.test(String(file.name || ""));
  if (!byMime && !byName) {
    throw new Error("Only PDF files are allowed.");
  }
};

export const createAdminAccessoryPdf = async ({ id, title, productSlug }) => {
  const body = { title: String(title || "").trim() };
  const slug = String(productSlug ?? "").trim();
  if (slug) body.productSlug = slug;
  const response = await apiClient.post(`/accessories/admin/${id}/pdfs`, body);
  return response.data;
};

export const updateAdminAccessoryPdf = async ({ id, pdfId, payload }) => {
  const response = await apiClient.put(`/accessories/admin/${id}/pdfs/${pdfId}`, payload);
  return response.data;
};

export const uploadAdminAccessoryPdfFile = async ({ id, pdfId, file }) => {
  assertPdfFile(file);
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.post(`/accessories/admin/${id}/pdfs/${pdfId}/file`, formData, {
    headers: { "Content-Type": false },
  });
  return response.data;
};

export const deleteAdminAccessoryPdf = async ({ id, pdfId }) => {
  const response = await apiClient.delete(`/accessories/admin/${id}/pdfs/${pdfId}`);
  return response.data;
};

export const clearAdminAccessoryPdfFile = async ({ id, pdfId }) => {
  const response = await apiClient.delete(`/accessories/admin/${id}/pdfs/${pdfId}/file`);
  return response.data;
};

// Backward-compatible aliases while dashboard component naming is still "Metals".
export const getAdminMetals = getAdminAccessories;
export const createAdminMetal = createAdminAccessory;
export const updateAdminMetal = updateAdminAccessory;
export const deleteAdminMetal = deleteAdminAccessory;
export const uploadAdminMetalImage = uploadAdminAccessoryImage;
export const removeAdminMetalImage = removeAdminAccessoryImage;
